import type { KaiTableContext } from "@/components/table";
import { buildBookingsTableContextSnapshot } from "@/features/bookings/bookingTablePrefs";

/**
 * Build the table-layout snapshot Kai receives in `client_context.table_context`
 * for the page the user is currently viewing, or `undefined` when the route
 * has no Kai-configurable table.
 */
export function buildKaiTableContext(
  pathname: string,
): KaiTableContext | undefined {
  if (pathname === "/bookings") {
    return buildBookingsTableContextSnapshot();
  }
  return undefined;
}
